import { Component,NgModule } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { PiyushService } from '../../services/piyush.service';
import { NgxSpinnerModule } from 'ngx-spinner';

import { User } from './User';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html'
})
@NgModule({
  
  imports: [NgxSpinnerModule],
  
  
})
export class LoginComponent { 
  private _piyushService
  constructor(private router: Router,
    private piyushService:PiyushService){
      this._piyushService = piyushService;
     }
  user = new User('','');
  goToDashBoard(loginForm:NgForm): void {
    this.user = Object.assign(this.user,loginForm.value);
    
    this._piyushService.getData('api/Login',this.user)
    .subscribe(
      data =>{
        localStorage.setItem('piyushToken',data.token);
        localStorage.setItem("piyushUser",data.usertype);
        localStorage.setItem("piyushUserLg",data.userNameLg);
        localStorage.setItem("piyushUserName",data.userid);
        localStorage.setItem("userBranch",data.userBranch);
        this._piyushService.success('Welcome '+data.userNameLg);
        const navigationDetails: string[] = ['courier/home'];
        this.router.navigate(navigationDetails);
      },
      error =>{
        this._piyushService.error('Login Failed');
        console.log(error);
        return;
      }
    );
    
   
    
  }
  goToRegister($myParam: string = ''): void {
    
    const navigationDetails: string[] = ['register'];
    if($myParam.length) {
      navigationDetails.push($myParam);
    }
    this.router.navigate(navigationDetails);
  }
}
